export const colors = {};

export const colorAliases = {};

export const zIndexes = {
  'z-index-overlay': 10,
  'z-index-backdrop': 998,
  'z-index-modal-wrapper': 999,
  'z-index-modal': 1000,
  'z-index-notification': 1001,
};

export const misc = {
  'form-sm': '320px',
};

export const theme = {
  ...colors,
  ...colorAliases,
  ...zIndexes,
  ...misc,
};
